export enum TimeMeasure {
  seconds = 'seconds',
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
  weeks = 'weeks',
  month = 'months',
  years = 'years',
}

export const getDateInTimeRange = (
  date: Date,
  diff: number,
  measure: TimeMeasure,
): Date => {
  const rangedDate = new Date(date);

  switch (measure) {
    case TimeMeasure.seconds:
      rangedDate.setSeconds(rangedDate.getSeconds() + diff);
      break;
    case TimeMeasure.minutes:
      rangedDate.setMinutes(rangedDate.getMinutes() + diff);
      break;
    case TimeMeasure.hours:
      rangedDate.setHours(rangedDate.getHours() + diff);
      break;
    case TimeMeasure.days:
      rangedDate.setDate(rangedDate.getDate() + diff);
      break;
    case TimeMeasure.weeks:
      rangedDate.setDate(rangedDate.getDate() + 7 * diff);
      break;
    case TimeMeasure.month:
      rangedDate.setMonth(rangedDate.getMonth() + diff);
      break;
    case TimeMeasure.years:
      rangedDate.setFullYear(rangedDate.getFullYear() + diff);
      break;
    default:
  }

  return rangedDate;
};
